export default __webpack_public_path__ + "static/media/portfolio-hover-176.9543d418.jpg";